import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import viewRelatedPermissions from './viewRelatedPermissions';
import viewRelatedOrg from './viewRelatedOrg';
import viewRelatedUserPermissions from './viewRelatedUserPermissions';

export default {
  attributeName: 'organizations',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have organizations, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the organization',
      canEdit: true,
      canFilter: true,
      canCreate: true,
      width: '12rem',
    },
    {
      attributeName: 'passwordExpiration',
      label: 'User Password Expiration',
      helpText: 'Whether or not the side panel is enable.',
      type: FormInputTypes.CHECKBOX,
      default: false,
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'loginAttempts',
      label: 'Limit Login Attempts',
      helpText: 'Limit the amount of login attempts until account becomes blocked for certain time',
      type: FormInputTypes.CHECKBOX,
      default: false,
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'agreements',
      label:'Agreements',
      type: FormInputTypes.LINK,
      icon: IconType.HANDSHAKE,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Live monitor for this event.',
    },   
  ],
};
